import React from "react";
import "./Features.css";
import { FaSearch, FaCompass, FaChartLine, FaBuilding } from "react-icons/fa";

const features = [
  {
    icon: <FaSearch />,
    title: "Job search",
    highlight: "Find a job",
  },
  {
    icon: <FaCompass />,
    title: "Career planning",
    highlight: "Choose a career",
  },
  {
    icon: <FaChartLine />,
    title: "Labour market information",
    highlight: "Explore opportunities",
  },
  {
    icon: <FaBuilding />,
    title: "Hiring",
    highlight: "Fill a position",
  },
];

const Features = () => {
  return (
    <section
     className="features">
      <div className="features-container">
        {features.map((item, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon">{item.icon}</div>
            <div className="feature-text">
              <span>{item.title}</span>
              <h4>{item.highlight}</h4>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;